/* This file was created automatically, don't change it manually. */

import React, { forwardRef } from 'react';

import { ColorlessIconProps } from '../../types';
import { SVGContainer } from '../../SVGContainer';

const IconClose8 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconClose8(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 8 8" ref={ref}>
            <path
                d="M3.529 4 1.334 1.805l.472-.472 2.195 2.195 2.194-2.195.472.472L4.473 4l2.194 2.195-.472.472-2.194-2.195-2.195 2.195-.472-.472L3.53 4Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconClose12 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconClose12(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 12 12" ref={ref}>
            <path
                d="M5.292 6 2 2.708 2.708 2 6 5.292 9.292 2l.708.708L6.708 6 10 9.292 9.292 10 6 6.708 2.708 10 2 9.292 5.292 6Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconClose16 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconClose16(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 16 16" ref={ref}>
            <path
                d="M7.055 8 2.666 3.61l.944-.943L8 7.057l4.389-4.39.944.944L8.943 8l4.39 4.388-.945.944L8 8.944l-4.389 4.39-.944-.945L7.056 8Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconClose20 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconClose20(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 20 20" ref={ref}>
            <path
                d="M8.82 10 3.335 4.513l1.18-1.18L10 8.82l5.486-5.487 1.18 1.18L11.181 10l5.486 5.487-1.18 1.18-5.486-5.487-5.487 5.487-1.18-1.18L8.821 10Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconClose24 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconClose24(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 24 24" ref={ref}>
            <path
                d="M10.584 12 4 5.416 5.416 4 12 10.584 18.584 4 20 5.416 13.416 12 20 18.584 18.584 20 12 13.416 5.416 20 4 18.584 10.584 12Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

export const IconClose = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconClose(props, ref) {
    const { size = '16', role = 'supplementary' } = props;

    const iconProps = {
        ...props,
        size,
        ref,
        role,
        colorless: true,
    } as const;

    switch (size) {
        case '8':
            return <IconClose8 {...iconProps} />;
        case '12':
            return <IconClose12 {...iconProps} />;
        case '16':
            return <IconClose16 {...iconProps} />;
        case '20':
            return <IconClose20 {...iconProps} />;
        case '24':
            return <IconClose24 {...iconProps} />;
        default:
            return <IconClose24 {...iconProps} />;
    }
});
